// Sayfalama için kullanılan sayfa başına kayıt sayıları
export const PAGE_SIZES = {
  SPARE_PARTS: 50,
  SERVICE_REQUESTS: 20,
  ORDERS: 20,
  MAINTENANCE_ENTRIES: 20,
} as const;

// Varsayılan sayfa başına kayıt sayısı
export const DEFAULT_PAGE_SIZE = 20; 